import { Button, TextInput } from 'components/Form'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { Field, Form, Formik } from 'formik'
import * as Yup from 'yup'
import { Success } from 'utils/alerts'
import { apiResetPassword } from 'services/AuthService'

const validationSchema = Yup.object().shape({
    password: Yup.string()
        .required('Enter your new password')
        .min(8, 'Too Short!')
        .matches(
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])/,
            'Must have Uppercase, Lowercase, Number and Special Character',
        ),
    confirm_password: Yup.string().oneOf(
        [Yup.ref('password'), null],
        'Password not match',
    ),
})

export default function ResetPassword() {
    const { uid, token } = useParams()
    const navigate = useNavigate()

    const onResetPassword = async (values, setSubmitting) => {
        setSubmitting(true)
        apiResetPassword({ uid, token, ...values })
            .then(() => {
                Success('Reset password successfully!')
                navigate('/login')
            })
            .catch((error) => error)
        setSubmitting(false)
    }

    return (
        <>
            <span className="flex justify-center">
                <img
                    className="w-[40%] h-[40%]"
                    src="/images/logo.png"
                    alt="error"
                />
            </span>
            {/* <h2 className="my-3 text-lg font-bold text-black dark:text-white sm:text-title-md">Reset Password</h2> */}
            <Formik
                initialValues={{
                    password: '',
                    confirm_password: '',
                }}
                validationSchema={validationSchema}
                onSubmit={(values, { setSubmitting }) => {
                    onResetPassword(values, setSubmitting)
                }}
            >
                {({ touched, errors, isSubmitting }) => (
                    <Form className="flex flex-col gap-3">
                        <Field name="password">
                            {({ field, form }) => (
                                <TextInput
                                    id="password"
                                    name="password"
                                    label={'Password'}
                                    autoComplete="password"
                                    password={true}
                                    error={errors.password && touched.password}
                                    message={errors.password}
                                    onChange={(e) =>
                                        form.setFieldValue(
                                            field.name,
                                            e.target.value,
                                        )
                                    }
                                />
                            )}
                        </Field>
                        <Field name="confirm_password">
                            {({ field, form }) => (
                                <TextInput
                                    id="confirm_password"
                                    name="confirm_password"
                                    label={'Confirm Password'}
                                    autoComplete="confirm password"
                                    password={true}
                                    error={
                                        errors.confirm_password &&
                                        touched.confirm_password
                                    }
                                    message={errors.confirm_password}
                                    onChange={(e) =>
                                        form.setFieldValue(
                                            field.name,
                                            e.target.value,
                                        )
                                    }
                                />
                            )}
                        </Field>
                        <Button
                            className="w-full mt-3 text-white border-primary bg-primary dark:border-secondary dark:bg-secondary"
                            disabled={isSubmitting}
                            type="submit"
                        >
                            {isSubmitting ? 'resetting...' : 'Reset Password'}
                        </Button>
                        <div className="text-center">
                            <p className="font-medium">
                                Back to{' '}
                                <Link to="/login" className="hover:underline">
                                    Sign in
                                </Link>
                            </p>
                        </div>
                    </Form>
                )}
            </Formik>
        </>
    )
}
